export default __webpack_public_path__ + "static/media/Montserrat-Light.a86efb4d.woff";